module.exports = __webpack_public_path__ + "static/media/elegant-thumbnail.d98346f6.png";